import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ApiResult } from "@/configs/axios";
import SettingService from "@/services/SettingService";
import { useUserStore } from "@/store";
import { storeToRefs } from "pinia";
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {
    const {
      token,
      userInfo
    } = storeToRefs(useUserStore());
    const currentId = ref('');
    const water = ref();
    const gaps = [[100, 100], [150, 150], [200, 200]];
    const exportRule = ['/editor/'];
    const previewRule = ['/play/', '/preview/', '/team_preview/'];
    const ruleRouter = ref([]);
    //const currentUrl = ref<string>('')
    const showWater = ref(false);
    const router = useRouter();
    const loadWater = async () => {
      if (!token.value || token.value == '') return;
      ruleRouter.value = [];
      const response = await SettingService.GetWmAsync();
      if (response.data.resultCode == ApiResult.SUCCESS) {
        water.value = response.data.data;
        if (water.value.ra == 0 || water.value.ra == 1) ruleRouter.value.push(...previewRule);
        if (water.value.ra == 0 || water.value.ra == 2) ruleRouter.value.push(...exportRule);
        waterVisibleHandler();
      }
    };
    const waterVisibleHandler = () => {
      const url = router.currentRoute.value.path;
      showWater.value = ruleRouter.value.findIndex(x => url.includes(x)) != -1;
    };
    const freeUserWatermake = () => {
      ruleRouter.value = [];
      ruleRouter.value.push(...previewRule);
      ruleRouter.value.push(...exportRule);
      water.value = {
        status: true,
        content: 'Travel Design',
        wmtype: 1,
        ag: -25,
        cz: 16,
        color: 'rgba(0,0,0,.1)',
        de: 2
      };
      showWater.value = true;
      waterVisibleHandler();
    };
    watch(() => router.currentRoute.value.path, toPath => {
      waterVisibleHandler();
    }, {
      immediate: true,
      deep: true
    });
    watch(() => userInfo.value, newUser => {
      let tempId = userInfo.value && userInfo.value.id ? userInfo.value.id : '';
      if (tempId != currentId.value) {
        if (userInfo.value.iv || userInfo.value.it) loadWater();else freeUserWatermake();
        currentId.value = tempId;
      }
    });
    if (userInfo.value && userInfo.value.id) currentId.value = userInfo.value.id;
    if (userInfo.value.iv || userInfo.value.it) loadWater();else freeUserWatermake();
    return (_ctx, _cache) => {
      const _component_el_watermark = _resolveComponent("el-watermark");
      return water.value && water.value.status && showWater.value ? (_openBlock(), _createBlock(_component_el_watermark, {
        key: 0,
        class: "travel-watermark",
        content: water.value.wmtype == 1 ? water.value.content : '',
        "z-index": 9999999,
        rotate: water.value.ag,
        gap: gaps[water.value.de - 1],
        offset: [0, 0],
        image: water.value.wmtype == 2 ? water.value.content : '',
        font: {
          fontSize: water.value.cz,
          color: water.value.color,
          fontWeight: 400
        }
      }, null, 8, ["content", "rotate", "gap", "image", "font"])) : _createCommentVNode("", true);
    };
  }
});